export const MAP_TEST_CASE_DIALOG_TITLE = "Link Test Cases confirmation";
export const UNSAVED_TEST_CASES_MESSAGE = `Do you want to save the changes before proceeding? Click "Save" to save to the changes or "Reject" to discard the changes`;
export const TEST_CASE_UNSAVED_MAPPING = `Do you want to save the changes? Click "Confirm" to save to the changes or "Reject" to discard the changes`;
export const generateNewTestCaseAddMessage = (testcaseName: string, l4LevelName: string) => `You are trying to add a test case: "${testcaseName}" from the library to "${l4LevelName}". Do you want to proceed?`;
export const LEVEL_NOT_OPEN_BEFORE_DROPPING = "You are trying to add the test case on the level which is not yet open. Please open the Level before adding the test case."
export const BUTTON_TEXT = {
  SAVE: 'Save',
  CANCEL: 'Cancel',
  CONFIRM: 'Confirm',
  CONTINUE: 'Continue',
  REJECT: 'Reject',
  GENERATE: 'Generate',
  RE_GENERATE: 'Regenerate',
  AUTOGENERATE: 'Auto Generate',
  AUTOGENERATE_PATH: 'Autogenerate path',
  OK: 'Ok',
  DELETE: 'Delete',
  CLOSE: 'Close',
  BACK_TO_CONFIG: 'Back to configuration',
  BACK_TO_AUTOGEN_PATH_SELECTION: 'Back to Autogenerate Path',
  SAVE_AS: 'Save as',
  BACK_TO_RESULTS: 'Back to Results',
  CONTINUE_WITH_SELECTED_BTN: 'Continue with Selected'
};
export const mapUnmappedTestCaseMessage = (testcaseProject: string, testcaseLibrary: string) => `"${testcaseProject}" will be mapped to "${testcaseLibrary}"`;
export const MAPPING_UNMAPPED_TEST_CASE_WITH_DIFFERENT_TEST_CASE = 'You are trying to map test cases with different content. The test case from the library will completely replace the test case from the project. If you are satisfied with this option, click Confirm.';
export const ADD_TEST_CASE = "Add Test Case";
export const MAPPING_TEST_CASE_WITH_EXISTING_MAPPING_MESSAGE ="You are trying to map, the library test case to the project test case, this will replace the existing application steps and bot details. If you are satisfied with this option, please click confirm.";
export const DOCUMENT_SUCCESSFULLY_DOWNLOADED = "Document downloaded successfully";
export const DOCUMENT_RENAME_SUCCESSFULLY = "Document renamed successfully";
export const FAILED_TO_LOAD_DOCUMENTS = "Failed to load documents";
export const DOCUMENT_UPLOAD_SUCCESSFULLY = "Document(s) uploaded successfully";
export const REGEX = "^[a-zA-Z0-9 \\-_\\(\\)\\{\\}\\[\\]\\.,;!@#\\$%\\^&+=~`]+$";
export const FILE_ALLOWED_REGEX = /(?:\.([^.]+))?$/;
export const BYTES_IN_1GB = 1 * 1024 * 1024 * 1024;
export const BYTES_IN_MB = 1024 * 1024; 
export const TICKET_URL = "https://deloitteus.service-now.com/sp?id=sc_cat_item&sys_id=0027aca34f3bd7c433c77bcd0210c72d&table=sc_cat_item&sysparm_value=TestAI";
export const STATUS_FETCHED_SUCCESS = "Status Fetched Successfully";
export const STORAGE_FORM_MESSAGE = "Upload cannot be completed. The selected files exceed the remaining repository space.To request an increase, please";